/**
 * carousel-init.js
 *
 * Reusable scroll-snap carousel initialiser.
 *
 * Usage:
 *   initCarousel({
 *     sectionId:         'featured-products-band-123456',  // wrapper element ID
 *     gridId:            'fpb-grid-123456',                // scrollable container ID
 *     cssPrefix:         'featured-products-band',         // BEM block prefix
 *     cardSelector:      '.card-wrapper',                  // selector for one card inside the grid
 *     desktopBreakpoint: 1024,                             // px — carousel below, grid at/above
 *     hasCarouselClass:  'fpb--has-carousel',              // modifier added to sectionId el when active
 *     activateWhen:      'breakpoint',                     // optional: 'breakpoint' (default) | 'overflow'
 *     scrollAmount:      'card',                           // optional: 'card' (default) | 'page'
 *   });
 *
 * activateWhen 'overflow' ignores desktopBreakpoint and activates only while the
 * grid's content is wider than the grid (re-checked on resize). scrollAmount 'page'
 * scrolls ~80% of the visible width per arrow click instead of one card.
 *
 * The section is responsible for:
 *   - CSS: arrow display gated on hasCarouselClass
 *   - CSS: switching flex↔grid at desktopBreakpoint
 *   - HTML: carousel-arrows snippet rendered inside a wrapper div
 */

function initCarousel(config) {
  var sectionEl  = document.getElementById(config.sectionId);
  var grid       = document.getElementById(config.gridId);
  if (!sectionEl || !grid) return;

  var cssPrefix        = config.cssPrefix;
  var cardSelector     = config.cardSelector     || '.card-wrapper';
  var breakpoint       = config.desktopBreakpoint || 1024;
  var hasCarouselClass = config.hasCarouselClass  || (cssPrefix + '--has-carousel');
  var activateWhen     = config.activateWhen      || 'breakpoint';
  var scrollAmount     = config.scrollAmount      || 'card';

  var prevBtn = sectionEl.querySelector('.' + cssPrefix + '__arrow--prev');
  var nextBtn = sectionEl.querySelector('.' + cssPrefix + '__arrow--next');

  function isCarousel() {
    if (activateWhen === 'overflow') return grid.scrollWidth > grid.clientWidth + 1;
    return window.innerWidth < breakpoint;
  }

  function cardWidth() {
    var first = grid.querySelector(cardSelector);
    if (!first) return 0;
    var gap = parseFloat(window.getComputedStyle(grid).columnGap) || 0;
    return first.offsetWidth + gap;
  }

  function scrollStep() {
    if (scrollAmount === 'page') return Math.max(grid.clientWidth * 0.8, cardWidth());
    return cardWidth();
  }

  function updateArrows() {
    if (!prevBtn || !nextBtn) return;
    prevBtn.disabled = grid.scrollLeft <= 1;
    nextBtn.disabled = grid.scrollLeft + grid.offsetWidth >= grid.scrollWidth - 1;
  }

  function activate() {
    sectionEl.classList.add(hasCarouselClass);
    updateArrows();
  }

  function deactivate() {
    sectionEl.classList.remove(hasCarouselClass);
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      grid.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      grid.scrollBy({ left: scrollStep(), behavior: 'smooth' });
    });
  }

  grid.addEventListener('scroll', updateArrows, { passive: true });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      isCarousel() ? activate() : deactivate();
    }, 100);
  });

  if (isCarousel()) activate();
}
